import { create } from "zustand";
import { persist } from "zustand/middleware";

const useDashboardStatsStore = create(
  persist(
    (set, get) => ({
      stats: null,
      lastFetched: null,

      setStats: (stats) =>
        set({ stats, lastFetched: Date.now() }),

      getStats: () => get().stats,

      clearStats: () => set({ stats: null, lastFetched: null }),
    }),
    {
      name: "dashboard-stats-cache",
      partialize: (state) => ({
        stats: state.stats,
        lastFetched: state.lastFetched,
      }),
    }
  )
);

export default useDashboardStatsStore;
